import { InjectionToken } from '@angular/core';
import { NDfPrivacy } from '@df/module-privacy/df-module-privacy.interfaces';

/**
 * Extend app.config with module properties
 * @see config/df.config.twig.part
 */
declare module '@df/core/df-core.config' {
    interface IDfConfig {
        oneTrust: {
            id: string;
            autoBlock?: string;
            autoBlockEnabled: boolean;
            sdk: string;
            enabled: boolean;
        };
    }
}
declare global {
    interface Window {
        OneTrust?: NDfModuleOnetrust.IApi;
        OnetrustActiveGroups?: string;
    }
}

export namespace NDfModuleOnetrust {
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_MODULE_ONETRUST_OPTIONS', {
        providedIn: 'root',
        factory: () => defaultOptions
    });

    /**
     * Global OneTrust configuration
     */
    export interface IModuleOptions {
        groups?: IGroup[];
    }

    export const defaultOptions: IModuleOptions = {
        groups: [
            {
                id: 'C0001',
                area: NDfPrivacy.AREA.core
            },
            {
                id: 'C0002',
                area: NDfPrivacy.AREA.performance
            },
            {
                id: 'C0003',
                area: NDfPrivacy.AREA.personalisation
            },
            {
                id: 'C0004',
                area: NDfPrivacy.AREA.advertising
            }
        ]
    };

    export interface IGroup {
        id: string | string[];
        area: NDfPrivacy.AREA;
    }

    export interface IGroupEvent extends Event {
        detail?: string[];
    }

    export interface IApi {
        ToggleInfoDisplay(): void;
        Init(): void;
        LoadBanner(): void;
    }
}
